import React from 'react'
import './style.css'
export default function Loader() {
  return (
    <span className="loader"></span>
  )
}
